// BookTickets/SummaryBox/SummaryFields.tsx
import React from 'react'
import cn from 'classnames'
import { SummaryField } from '..'
import styles from '../index.module.scss'

export const SummaryFields = ({ availableFields }: { availableFields: SummaryField[] }) => {
  return (
    <div className={styles.itemList}>
      {availableFields.map(
        (item, index) =>
          item.show && (
            <div className={cn(styles.item, item.alignable && styles.alignable)} key={index}>
              <div className={styles.name}>{item.name}</div>
              <div className={styles.value}>{item.value}</div>
            </div>
          ),
      )}
    </div>
  )
}
